import React from 'react';
import { Modal } from 'react-bootstrap';

interface FilePreviewModalProps {
  show: boolean;
  onHide: () => void;
  file: File;
}

export const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  show,
  onHide,
  file,
}) => {
  const isVideo = file.type.startsWith('video/');
  const isPdf = file.type === 'application/pdf';
  const fileUrl = URL.createObjectURL(file);

  const renderContent = () => {
    if (isVideo) {
      return (
        <video
          controls
          style={{ width: '100%', maxHeight: '70vh' }}
          src={fileUrl}
        >
          Seu navegador não suporta o elemento de vídeo.
        </video>
      );
    }

    if (isPdf) {
      return (
        <iframe
          src={fileUrl}
          style={{ width: '100%', height: '70vh', border: 'none' }}
          title="PDF Preview"
        />
      );
    }

    return (
      <div className="text-center p-4">
        <p>Preview não disponível para este tipo de arquivo.</p>
        <p>Tipo: {file.type}</p>
        <p>Tamanho: {(file.size / 1024 / 1024).toFixed(2)} MB</p>
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{file.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderContent()}
      </Modal.Body>
    </Modal>
  );
};
